export default "mutation removeCategory($id: String) {\n  removeCategory(id: $id) \n}";